// extracted by mini-css-extract-plugin
export default {"container":"SubscriptionPaused_container__RZjNT","progressBar":"SubscriptionPaused_progressBar__8-CkW"};